import { createAppAsyncThunk } from '@/lib/redux/createAppAsyncThunk';
import { userSlice } from './slice';
import { queryMemberInfo, queryMemberCertify, queryLastCertify } from './api';
import { selectUser, type ReduxThunkAction } from '@/lib/redux';

/**
 * 查询会员信息
 */
export const queryMemberInfoAsync = createAppAsyncThunk('user/queryMemberInfo', async (param: { time: number; force?: boolean }) => {
  const { time, force } = param;
  if (Date.now() - time > 1000 * 60 * 5 || force) {
    return await queryMemberInfo();
  }
  return undefined;
});

/**
 * 查询认证信息
 * @param identifyCodeList 认证编码
 */
export const getMemberCertifyAsync =
  (identifyCodeList: string[]): ReduxThunkAction =>
  async (dispatch, getState) => {
    const user = selectUser(getState());
    if (!user.loginUser) {
      return;
    }
    const data = await queryMemberCertify(identifyCodeList);
    dispatch(userSlice.actions.setUserCertify(data));
  };

/**
 * 查询最后一次认证状态
 * @param identifyCode 认证码
 */
export const getMemberLastCertifyAsync =
  (identifyCode: string): ReduxThunkAction =>
  async (dispatch, getState) => {
    const user = selectUser(getState());
    if (!user.loginUser) {
      return;
    }
    const data = await queryLastCertify(identifyCode);
    dispatch(userSlice.actions.setLastCertifyStatus(data));
  };
